import { useState } from "react";
import { useTranslation } from "react-i18next";
import { truncateVideoText } from "../../../../utils/string-helpers";
import SvgIcon from "../../../../parts/SvgIcon";

const fileLimit = 200;

const VideoUpload = ({
  form,
  video,
  explanationVideo = false,
  goBack = () => {},
}) => {
  const { t } = useTranslation("coaching-portal");
  const hasVideoUrl = typeof video === "string";
  const [videoUrl, setVideoUrl] = useState(hasVideoUrl ? video : "");
  const [fileName, setFileName] = useState(video?.fileName || "");
  const [deleteVideo, setDeleteVideo] = useState(false);
  const [isOutOfLimit, setIsOutOfLimit] = useState(false);

  const cleanVideoField = () => {
    setFileName("");
    setDeleteVideo(video?.fileName || "");
  };

  const showDisableVideoInputClassUrl = videoUrl ? "disable-video-input" : "";

  return (
    <>
      {explanationVideo ? (
        <div className="explanation-video">
          <SvgIcon src="/img/new-icons/back-button.svg" onClickFn={goBack} />
          <div>
            <p className="s2">{t("customWorkflows.addExplanationVideo")}</p>
          </div>
        </div>
      ) : null}
      <input name="deleteVideo" value={deleteVideo} type="hidden" />
      <div className="form-row-item">
        <label className={`sub-label ${showDisableVideoInputClassUrl}`}>
          {t("customWorkflows.uploadVideoLabel")}
          {isOutOfLimit && ` - ${t("customWorkflows.fileTooBig")}`}
        </label>
        <label
          className={`video-input${
            fileName ? " uploaded" : ""
          } ${showDisableVideoInputClassUrl}`}
        >
          <div>
            <SvgIcon
              src={
                fileName
                  ? "/img/new-icons/Video.svg"
                  : "/img/new-icons/upload-file.svg"
              }
              noFilterOnLight={!fileName}
            />{" "}
            {fileName
              ? `${
                  truncateVideoText(fileName) ||
                  truncateVideoText(
                    fileName.split("\\")[fileName.split("\\").length - 1]
                  )
                }`
              : t("customWorkflows.chooseFile")}
          </div>
          {fileName && (
            <button
              data-button-type="secondary"
              data-icon-only={true}
              data-icon={true}
              onClick={(e) => {
                e.preventDefault();
                cleanVideoField();
              }}
            >
              <SvgIcon
                src="/img/new-icons/red-trash.svg"
                noFilterOnLight={true}
              />
            </button>
          )}
          <input
            className={`text-input file-input-other-form ${showDisableVideoInputClassUrl}`}
            type="file"
            name="videoFile"
            disabled={!!videoUrl}
            onChange={(e) => {
              if (e?.target?.files[0]?.size > fileLimit * 1024 * 1024) {
                setIsOutOfLimit(true);
                e.target.value = "";
                return;
              }
              setIsOutOfLimit(false);

              setFileName(e.target.value);
            }}
            form={form}
          />
        </label>
      </div>

      <div className="divider">
        <span className="line" />
        <p className="p5">{t("customWorkflows.or")}</p>
        <span className="line" />
      </div>

      <div className="form-row-item">
        <label
          className={`sub-label ${fileName ? "disable-video-input" : ""}`}
          htmlFor="videoUrl"
        >
          {t("customWorkflows.enterUrl")}
        </label>
        <input
          className="url-input"
          type="text"
          name="videoUrl"
          placeholder={fileName ? "" : t("customWorkflows.pasteYoutubePlaceholder")}
          value={videoUrl || ""}
          onChange={(e) => setVideoUrl(e.target.value)}
          disabled={fileName}
          form={form}
        />
      </div>
    </>
  );
};

export default VideoUpload;
